import { create } from 'zustand'
import { createPortal } from 'react-dom'

type LoadingState = {
    count: number
    isLoading: boolean
    start: () => void
    stop: () => void
    reset: () => void
}

const useLoadingStore = create<LoadingState>((set, get) => ({
    count: 0,
    isLoading: false,
    start: () => {
        const c = get().count + 1
        set({ count: c, isLoading: true })
    },
    stop: () => {
        const c = Math.max(0, get().count - 1)
        set({ count: c, isLoading: c > 0 })
    },
    reset: () => set({ count: 0, isLoading: false }),
}));
//non react code uses this
export const startNonReactLoading = () => useLoadingStore.getState().start()
export const stopNonReactLoading  = () => useLoadingStore.getState().stop()

export function GlobalLoader() {
    const isLoading = useLoadingStore(s => s.isLoading)
    if (typeof document === 'undefined' || !isLoading) return null

    return createPortal(
        <div className="fixed top-0 left-0 w-full h-1.5 z-[999] bg-gray-100 overflow-hidden">
            <div className="w-full h-full relative">
                <div
                    className="absolute inset-0 h-full bg-gradient-to-r from-blue-500 via-blue-600 to-blue-500"
                    style={{ animation: 'shimmer 1.5s linear infinite', backgroundSize: '200% 100%' }}
                />
                <div
                    className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white to-transparent"
                    style={{ animation: 'slide 1.5s ease-in-out infinite', opacity: 0.2 }}
                />
            </div>
            <style>{`
        @keyframes shimmer { 0% { background-position: 100% 0; } 100% { background-position: -100% 0; } }
        @keyframes slide { 0% { transform: translateX(-100%); } 100% { transform: translateX(200%); } }
      `}</style>
        </div>,
        document.body
    )
}